import "./Equipment.module.css";
import Header from "@/reusable_sections/Header";
import EliteFleetGallery from "./sections/EliteFleetGallery";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function EquipmentPage() {
  return <div>
      <Header />
      <EliteFleetGallery />
      <CommonInquiries />
      <Footer />
    </div>;
}